import React, { Component } from 'react'

import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,  MDBBreadcrumb, MDBBreadcrumbItem } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBJumbotron, MDBBox } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead,  } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
//import Login from './Login';
import Axios from 'axios'
import { URL } from '../../api';
import logo from '../img/logokpru.png'
import FadeIn from 'react-fade-in';
import p1 from '../img/1656587759_2-illustration_png.png'
import p2 from '../img/1656587759_4-illustration_png.png'
import p3 from '../img/1656587761_12-illustration_png.png'
import p4 from '../img/1656587766_35-illustration_png.png'
import Iframe from 'react-iframe'


import { HorizontalBar } from 'react-chartjs-2';


import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';

var xlsx = require("xlsx");


export default class Publicall extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,
      datastuKamphaengphet:[],
      team: '2565',

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onClick2 = this.onClick2.bind(this);
    this.readUploadFile = this.readUploadFile.bind(this);
    this.refreshPage = this.refreshPage.bind(this);

  }

  refreshPage() {
    window.location.reload(false);
  }
  
  componentDidMount() {
    // fetch('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json', {
    //     method: 'GET',
    //     body: JSON.stringify(),
    //     headers: {
           
    //     }

    //   })
    //     .then(res => res.json())
    //     .then((res) => {
    //         this.setState({ datastuKamphaengphet: res })
    //     })
    //     .catch(err => {
    //       console.log('request failed', err);
    //     })



//         Axios.get('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json',{
         
//         })
//         .then((res) => {
//        console.log(res.data)
      
//        this.setState({ datastuKamphaengphet: res })
//    })

  }

 onClick2() {
     console.log('dd')
          Axios.get('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json')
         .then((res) => {
      //  console.log(res.data)
       
        this.setState({ datastuKamphaengphet: res })
    })

  }


  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }


  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }




  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }

  readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);
         //   console.log(json);
            this.setState({ datastuKamphaengphet: json })

        };
        reader.readAsArrayBuffer(e.target.files[0]);
    }
}


  render() {
    const dUrl = "https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json";

  // console.log(dUrl);
   console.log(this.state.datastuKamphaengphet)
 //console.log('dd')
    const dataHorizontal = {
      labels: ['Red', 'Orange', 'Yellow', 'Green', 'Blue', 'Purple', 'Grey'],
      datasets: [
        {
          label: 'My First Dataset',
          data: [22, 33, 55, 12, 86, 23, 14],
          fill: false,
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(201, 203, 207, 0.2)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
          ],
          borderWidth: 1
        }
      ]
    }



    return (

      <MDBContainer className="jum" fluid >
       
       <MDBRow >
          <MDBCol md="12">
            <div>
              {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
              {/* <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/> */}
              <FadeIn>
              <MDBJumbotron className="p-4 jum" fluid >
                 
                <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />   จำนวนตีพิมพ์เผยแพร่
                </MDBTypography>
                {/* <MDBTypography note noteColor='primary' noteTitle='ด้านนักศึกษา '> </MDBTypography> */}
                   <MDBBreadcrumb>
                        <MDBBreadcrumbItem>จำนวนตีพิมพ์เผยแพร่</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>จำนวนตีพิมพ์เผยแพร่</MDBBreadcrumbItem>
                    </MDBBreadcrumb>
                    <div className='text-right'> <a href='/welcome'><MDBBtn  color="blue-grey" size='sm'><MDBIcon icon="caret-left" /> กลับหน้าหลัก</MDBBtn></a><MDBBtn  color="mdb-color" size='sm' onClick={this.refreshPage}><MDBIcon icon="redo" /> refresh</MDBBtn></div>
        
                            {/* <br/> */}
                            <p>ระบบโหลดข้อมูลจำนวนมาก กรุณารอสักครู่</p>
                         
                              <Iframe url="https://lookerstudio.google.com/embed/reporting/f47d7410-c8c3-4222-b656-5fe7acf8d5dc/page/6EekD"
                                 width="100%"
                                 height="800px"
                                 id=""
                                 className=""
                                 display=""
                                 position="relative"/>
                              


             
              </MDBJumbotron>

       

              </FadeIn>
            </div>
          </MDBCol>
        </MDBRow>

      </MDBContainer>


    )
  }
}
